import React, {useEffect, useState} from 'react';
import {isEmpty} from 'lodash';

import {DASHBOARD_TOP_TABS_VALUE} from '../../utils/constants.js';
import {
    COMPETITION_TAB_KEYS,
    COMPETITION_TABS,
    generateGetUrlDashboardSummary,
    getFilteredSummaryData,
    getFiltersRawData,
    getFromToDate
} from '../shared/charts-and-grids/charts-util.js';
import useApi from '../../api-wrapper/use-api.js';

import ToggleLinks from '../../ui-components/toggle-links/toggle-links.jsx';
import ChartCompetitionFareChanges
    from '../shared/charts-and-grids/chart-competition-fare-changes/chart-competition-fare-changes.jsx';

const CompetitionContainer = ({
                                  searchCriteriaPayload,
                                  recommCompetitor,
                                  setIsOpenSearchModalHandler,
                                  setIsShowNotification,
                                  filterBy,
                                  onChangeFilterName,
                                  isFareChangesSummaryFromAthena,
                                  setCommonFiltersHandler,
                              }) => {

    const [competitionFares, setCompetitionFaresChartData] = useState(COMPETITION_TAB_KEYS.FARES);
    const [fareChangesSummaryData, fetchFareChangesSummaryData] = useApi([{method: 'POST', url: searchCriteriaPayload}]);
    const [filteredFareChangesSummaryData, setFilteredFareChangesSummaryData] = useState([]);
    const getCompetitionSummaryData = chartData => {
        return isFareChangesSummaryFromAthena ? (chartData ? chartData.data : []) : (chartData ? chartData.data.fareChangesSummaryList : []);
    }

    useEffect(() => {
        const summaryData = getCompetitionSummaryData(fareChangesSummaryData);
        if (isEmpty(summaryData)) {
            setIsOpenSearchModalHandler(true);
            const isNoRecordsExists = isFareChangesSummaryFromAthena ?
                (fareChangesSummaryData && fareChangesSummaryData.data && fareChangesSummaryData.data.length === 0) :
                (fareChangesSummaryData && fareChangesSummaryData.data && fareChangesSummaryData.data.totalCount === 0);
            if (isNoRecordsExists) {
                setIsShowNotification(true);
            }
        } else {
            const fromTo = getFromToDate(searchCriteriaPayload);
            const availableFilters = getFiltersRawData(summaryData, fromTo, recommCompetitor);
            setCommonFiltersHandler(availableFilters, `${DASHBOARD_TOP_TABS_VALUE.COMPETITION}_SUMMARY`);
            setIsOpenSearchModalHandler(false);
        }
    }, [fareChangesSummaryData]);

    useEffect(() => {
        fetchFareChangesSummaryData(generateGetUrlDashboardSummary(DASHBOARD_TOP_TABS_VALUE.COMPETITION, searchCriteriaPayload, recommCompetitor, isFareChangesSummaryFromAthena));
    }, [searchCriteriaPayload]);

    useEffect(() => {
        if (isEmpty(fareChangesSummaryData) || isEmpty(filterBy)) {
            return;
        }
        setFilteredFareChangesSummaryData(getFilteredSummaryData(getCompetitionSummaryData(fareChangesSummaryData), filterBy, '', recommCompetitor, onChangeFilterName));
    }, [filterBy, onChangeFilterName]);

    const handleCompetitionTabOnClick = competitionFaresTab => {
        setCompetitionFaresChartData(competitionFaresTab);
    };

    return (
        <>
            <ToggleLinks
                toggleLinkOnClickHandler={handleCompetitionTabOnClick}
                selectedToggleLink={competitionFares}
                toggleLinks={COMPETITION_TABS}
            />

            <ChartCompetitionFareChanges
                filteredFareChangesSummaryData={filteredFareChangesSummaryData}
                filterBy={filterBy}
                searchCriteriaPayload={searchCriteriaPayload}
            />
        </>
    );
};

CompetitionContainer.propTypes = {};

export default CompetitionContainer;
